<script setup lang="ts">
import { Zap } from 'lucide-vue-next';
</script>

<template>
  <section class="relative overflow-hidden pt-16 bg-gradient-to-b from-slate-50 via-white to-slate-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <div class="text-center max-w-3xl mx-auto mb-16">
        <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-indigo-50 text-indigo-700 font-semibold text-sm mb-6 border border-indigo-100">
          <Zap class="h-4 w-4 fill-indigo-500" />
          <span>Nowość: sprawdź Resume Score za darmo</span>
        </div>
        <h1 class="text-5xl md:text-6xl font-extrabold tracking-tight mb-6 leading-tight">
          Przestań wysyłać CV. <br />
          <span class="bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-violet-600">
            Zacznij dostarczać odpowiedzi.
          </span>
        </h1>
        <p class="text-xl text-slate-600 mb-10 leading-relaxed">
          Rekruterzy poświęcają tylko 6 sekund na przejrzenie CV. Spraw, by w tym czasie dostrzegli Ciebie.
        </p>
      </div>
    </div>
  </section>
</template>
